const fetchEquipmentStatusLogUseCase = (repository) => async (pagination, search, logType) => {
    const payload = {
        sort: pagination.sortBy.map((s) => [s]).join(','),
        descending: pagination.sortDesc.join(','),
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        startDate: pagination.startDate,
        endDate: pagination.endDate,
        equipmentStatusID: pagination.equipmentStatusID,
        search: search,
        equipmentStatusLogTypeID: logType,
    }
    return await repository(payload);
}

export default fetchEquipmentStatusLogUseCase;